// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"358a238f","449":"8185d4ec","489":"f4b93af5","785":"e5a4612e","817":"35228385"}[chunkId] + ".chunk.js";
};